export default __webpack_public_path__ + "static/media/bathroom1-after-1024w.6600b3fa.png";